// extracted by mini-css-extract-plugin
export var completionBody = "_bw-2";
export var completionCard = "_bw-0";
export var completionFooter = "_bw-3";
export var completionTitle = "_bw-1";